import { gql } from '@apollo/client';

export default gql`
  mutation ($auth_as_user: String!) {
    authAs(auth_as_user: $auth_as_user)
  }
`;
